import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { graphql } from "react-apollo";
import { mutationAddAgent } from "Apollo";
import { ShowNotice } from "Store";
import Modal from "module-common/Modal";
import Button from "module-common/Button";
import InputRowRaw from "module-common/InputRow";

export default graphql(mutationAddAgent)(
  class InviteModal extends Component {
    static propTypes = {
      onCancel: PropTypes.func,
      onConfirm: PropTypes.func
    };
    state = {
      username: "",
      name: "",
      email: ""
    };

    render() {
      const { onCancel } = this.props;
      const { username, name, email, loading } = this.state;
      return (
        <Modal>
          <Wrapper>
            <Text>Add Agent</Text>
            <form
              onSubmit={event => {
                this.onConfirm();
                event.preventDefault();
              }}
            >
              <InputRow
                labelWidth={100}
                label="Username"
                value={username}
                onChange={text => {
                  this.setState({ username: text });
                }}
              />
              <InputRow
                labelWidth={100}
                label="Name"
                value={name}
                onChange={text => {
                  this.setState({ name: text });
                }}
              />
              <InputRow
                labelWidth={100}
                label="Email"
                value={email}
                onChange={text => {
                  this.setState({ email: text });
                }}
              />
              <SubmitButton type="submit" />
            </form>
            <Buttons>
              <Button
                width={100}
                onClick={onCancel}
                color="gray"
                disabled={loading}
              >
                Cancel
              </Button>
              <Button
                width={100}
                onClick={this.onConfirm}
                loading={loading}
                disabled={loading}
              >
                Add
              </Button>
            </Buttons>
          </Wrapper>
        </Modal>
      );
    }

    onConfirm = async () => {
      const { onConfirm, mutate } = this.props;
      const { username, name, email } = this.state;

      if (onConfirm) {
        if (username && name && email) {
          this.setState({ loading: true });
          try {
            await mutate({
              variables: { username, name, email },
              refetchQueries: ["getAgents"]
            });
            onConfirm();
            ShowNotice("team-agent-add-success");
          } catch (e) {
            ShowNotice("team-agent-add-error");
          }
          this.setState({ loading: false });
        } else {
          ShowNotice("team-agent-incomplete-field-error");
        }
      }
    };
  }
);

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 320px;
  align-items: center;
`;
const Text = styled.div`
  color: ${props => props.theme.uiText};
  text-align: center;
  font-size: 1.2rem;
  margin-bottom: 10px;
`;
const Buttons = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  & > *:first-child {
    margin-right: 20px;
  }
`;
const SubmitButton = styled.button`
  display: none;
`;
const InputRow = styled(InputRowRaw)`
  margin-bottom: 10px;
`;



// WEBPACK FOOTER //
// ./src/module-supervisor-setting/team-panel/InviteModalWithMutation.js